import StaticPageLayout from "@/components/layout/StaticPageLayout";
import { useLanguage } from "@/context/LanguageContext";

export default function Grievances() {
  const { language } = useLanguage();

  const contentEn = (
    <div className="space-y-6 text-sm text-muted-foreground leading-relaxed">
      <p>
        At Hamarsathi, safety, respect, and trust are the cornerstones of our matchmaking community. We are fully compliant with the Information Technology Rules, 2021. If you encounter any issues, fraud, harassment, or violation of our Terms of Use, please reach out immediately. We are committed to maintaining a safe space for matrimonial searches.
      </p>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">1. Designated Grievance Officer Details</h2>
        <p>
          In accordance with Information Technology Act 2000 and rules made there under, the name and contact details of the Grievance Officer of Hamarsathi.com are published below:
        </p>
        <div className="bg-slate-50 border border-slate-200/60 p-4 rounded-xl space-y-1.5 text-foreground">
          <div><strong>Name:</strong> Prince Raj</div>
          <div><strong>Designation:</strong> Grievance Redressal & Compliance Officer</div>
          <div><strong>Address:</strong> Adpixa Office, Hazaribagh, Jharkhand, India - 825301</div>
          <div><strong>Email Support:</strong> <a href="mailto:grievances@hamarsathi.com" className="text-primary underline">grievances@hamarsathi.com</a></div>
          <div><strong>Alternate Contact:</strong> <a href="mailto:info@hamarsathi.com" className="text-primary underline">info@hamarsathi.com</a></div>
        </div>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">2. Grievance Escalation & Resolution Process</h2>
        <p>We handle all customer complaints and safety reports with a strict time-bound mechanism:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li><strong>Acknowledgment:</strong> All complaints received via email are acknowledged with a unique tracking ticket within <strong>24 hours</strong>.</li>
          <li><strong>Investigation:</strong> Our trust and safety team will look into the reported profile, investigate chat logs, verify provided documents, and if necessary, request additional proof from either party.</li>
          <li><strong>Resolution:</strong> The resolution (which may include warning, temporary suspension, permanent banning, or clearing of profile status) is executed and communicated within <strong>48 to 72 hours</strong>. The maximum statutory timeline for final disposal is 15 days.</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">3. Prohibited Misuse & Law Enforcement</h2>
        <p>
          Hamarsathi operates under a <strong>Zero-Tolerance Policy</strong> for monetary scams, dowry solicitations, obscene content, and fake profile creation. In cases of financial fraud, cyber-stalking, or blackmail, we cooperate fully with local law enforcement agencies and cyber cell departments by providing necessary login IPs, registration logs, and verification data as permitted by law.
        </p>
      </section>
    </div>
  );

  const contentHi = (
    <div className="space-y-6 text-sm text-muted-foreground leading-relaxed">
      <p>
        हमरसाथी में, सुरक्षा, सम्मान और विश्वास हमारे वैवाहिक समुदाय के प्रमुख आधार हैं। हम सूचना प्रौद्योगिकी नियम, 2021 के तहत पूर्ण रूप से अनुपालन करते हैं। यदि आपको उपयोगकर्ता के व्यवहार, उत्पीड़न, वित्तीय धोखाधड़ी या हमारे नियमों के उल्लंघन के संबंध में कोई समस्या है, तो कृपया तुरंत हमसे संपर्क करें।
      </p>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">1. नामित शिकायत अधिकारी का विवरण</h2>
        <p>
          सूचना प्रौद्योगिकी अधिनियम 2000 और उसके तहत बनाए गए नियमों के अनुसार, हमरसाथी (Hamarsathi.com) के शिकायत अधिकारी का नाम और संपर्क विवरण नीचे दिया गया है:
        </p>
        <div className="bg-slate-50 border border-slate-200/60 p-4 rounded-xl space-y-1.5 text-foreground">
          <div><strong>नाम:</strong> प्रिंस राज</div>
          <div><strong>पद:</strong> शिकायत निवारण एवं अनुपालन अधिकारी</div>
          <div><strong>पता:</strong> एडपिक्सा ऑफिस, हजारीबाग, झारखंड, भारत - 825301</div>
          <div><strong>ईमेल समर्थन:</strong> <a href="mailto:grievances@hamarsathi.com" className="text-primary underline">grievances@hamarsathi.com</a></div>
          <div><strong>वैकल्पिक ईमेल:</strong> <a href="mailto:info@hamarsathi.com" className="text-primary underline">info@hamarsathi.com</a></div>
        </div>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">2. शिकायत निवारण एवं समाधान प्रक्रिया</h2>
        <p>हम सभी शिकायतों और सुरक्षा रिपोर्टों को एक निश्चित समय सीमा के भीतर हल करते हैं:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li><strong>स्वीकृति (Acknowledgment):</strong> ईमेल द्वारा प्राप्त सभी शिकायतों की रसीद <strong>24 घंटे</strong> के भीतर एक विशिष्ट टिकट नंबर के साथ भेजी जाती है।</li>
          <li><strong>जांच:</strong> हमारी सुरक्षा टीम रिपोर्ट किए गए प्रोफाइल, चैट लॉग की जांच करेगी और यदि आवश्यक हो तो दोनों पक्षों से अतिरिक्त सबूत मांगेगी।</li>
          <li><strong>समाधान:</strong> जांच के निष्कर्ष के आधार पर चेतावनी, खाता निलंबन, या स्थायी प्रतिबंध जैसी कार्रवाई **48 से 72 घंटों** के भीतर की जाती है। अधिकतम कानूनी समाधान सीमा 15 दिनों की है।</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">3. कानून प्रवर्तन एवं सुरक्षा सहयोग</h2>
        <p>
          हमरसाथी वित्तीय घोटालों, दहेज की मांग, अश्लील सामग्री और नकली प्रोफाइल बनाने के खिलाफ **शून्य-असहिष्णुता (Zero-Tolerance) नीति** रखता है। वित्तीय धोखाधड़ी या साइबर-उत्पीड़न के मामलों में, हम पुलिस अधिकारियों और साइबर सेल विभाग को आवश्यक आईपी एड्रेस, पंजीकरण लॉग और सत्यापन डेटा प्रदान करके कानून प्रवर्तन एजेंसियों का पूरा सहयोग करते हैं।
        </p>
      </section>
    </div>
  );

  return (
    <StaticPageLayout
      title={language === "hi" ? "शिकायत निवारण" : "Grievance Redressal"}
      subtitle={language === "hi" ? "शिकायतों का समाधान और सुरक्षा सहायता" : "Grievance redressal and safety support"}
    >
      {language === "hi" ? contentHi : contentEn}
    </StaticPageLayout>
  );
}
